import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Button, MenuItem } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { BackdropLoader, SelectMenu, SimpleModal } from '@livable/saas-react-components';
import { useStore } from 'src/stores';
import { ASSIGNABLE_SUBSCRIPTION_STATUSES, SUBSCRIPTION_STATUS_CANCELED } from '../initialState';
export const ChangeStatusModal = observer(function ChangeStatusModal(_ref) {
  var _store$stripe$bulkUpd, _store$stripe$bulkUpd2;
  let isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    initialStatus = _ref.initialStatus,
    onApply = _ref.onApply,
    _ref$selectedSubscrip = _ref.selectedSubscriptionIds,
    selectedSubscriptionIds = _ref$selectedSubscrip === void 0 ? [] : _ref$selectedSubscrip,
    _ref$hasCanceledSelec = _ref.hasCanceledSelection,
    hasCanceledSelection = _ref$hasCanceledSelec === void 0 ? false : _ref$hasCanceledSelec;
  const store = useStore();
  const _useState = useState(initialStatus || ASSIGNABLE_SUBSCRIPTION_STATUSES[0] || ''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedStatus = _useState2[0],
    setSelectedStatus = _useState2[1];
  useEffect(() => {
    if (isOpen) {
      setSelectedStatus(initialStatus || ASSIGNABLE_SUBSCRIPTION_STATUSES[0] || '');
    }
  }, [isOpen, initialStatus]);
  const isLoading = (_store$stripe$bulkUpd = (_store$stripe$bulkUpd2 = store.stripe.bulkUpdateSubscriptionsAsync) === null || _store$stripe$bulkUpd2 === void 0 ? void 0 : _store$stripe$bulkUpd2.inProgress) !== null && _store$stripe$bulkUpd !== void 0 ? _store$stripe$bulkUpd : false;
  const statusOptions = initialStatus === SUBSCRIPTION_STATUS_CANCELED ? [SUBSCRIPTION_STATUS_CANCELED, ...ASSIGNABLE_SUBSCRIPTION_STATUSES] : ASSIGNABLE_SUBSCRIPTION_STATUSES;
  const handleApply = async () => {
    const ids = Array.isArray(selectedSubscriptionIds) ? selectedSubscriptionIds.filter(Boolean) : [];
    if (ids.length === 0) {
      onApply === null || onApply === void 0 || onApply();
      return;
    }
    try {
      await store.stripe.bulkUpdateSubscriptionsAsync.run({
        subscriptionIds: ids,
        priceIds: null,
        status: selectedStatus
      });
      onApply === null || onApply === void 0 || onApply();
    } catch (err) {
      console.error('Bulk update subscriptions failed:', err);
    }
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: null,
    isOpen: isOpen,
    handleClose: onClose,
    title: "Change status",
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: handleApply,
      disabled: isLoading || hasCanceledSelection
    }, isLoading ? 'Applying...' : 'Apply')
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    id: "change-status",
    labelId: "change-status-label",
    label: "Status",
    value: selectedStatus,
    disabled: hasCanceledSelection,
    onChange: e => setSelectedStatus(e.target.value)
  }, statusOptions.map(status => /*#__PURE__*/React.createElement(MenuItem, {
    key: status,
    value: status
  }, status))));
});